import React, { useEffect, useState } from "react";
import { Wrapper } from "./MaxLegWidget.styled";
import { callGetApiWithAuth } from "utils/api";
import {
    message,
    Spin,
} from "components/common";
import { asVolume } from "utils/text";
import StatsCard from "components/common/statsCard/StatsCard";
import { useSelector } from "react-redux";

export default function MaxLegWidget() {

    const [isStatLoaded, setIsStatLoaded] = useState(false);
    const [isPdownlineLoaded, setIsPdownlineLoaded] = useState(false);
    const [statData, setStatData] = useState({
        rank: { name: "Unranked" },
        next_rank: { name: "Director" },
        mp: 0,
        ap: 0,
        qop: 0,
        next_mp: 0,
        next_ap: 0,
        next_qop: 0,
        mp_percent: 0,
        ap_percent: 0,
        qop_percent: 0,
        c_cnt: 0,
        tl_cnt: 0,
        stl_cnt: 0,
        leg_chart: 0,
        has_qop_chart: false,
    });
    const myUser = useSelector(state => state.auth.user)

    const [pdownlineData, setPdownlineData] = useState({
        top3: [],
        otherLegsOp: 0
    })

    const onGetStatData = (res) => {
        if (!res.success) {
            return message.error(res.message);
        }
        setStatData(res.data);
        setIsStatLoaded(true);
    };
    const onFailStatData = () => {
        setIsStatLoaded(true);
    };

    const onGetPdownlineData = (res) => {
        if (!res.success) {
            return message.error(res.message);
        }
        setPdownlineData(res.data);
        setIsPdownlineLoaded(true);
    };
    const onFailPdownlineData = () => {
        setIsPdownlineLoaded(true);
    };


    useEffect(() => {
        setIsStatLoaded(false);
        setIsPdownlineLoaded(false);
        callGetApiWithAuth(
            "my_rank/rank_tracker/builder_rank/rank_stats",
            onGetStatData,
            onFailStatData
        );
        callGetApiWithAuth(
            "my_rank/rank_tracker/builder_rank/pdownline_stats",
            onGetPdownlineData,
            onFailPdownlineData
        );
    }, []);
    return (
        <Wrapper>
            <div className="widget-grid">
                {/* MP + CP */}
                <div className="widget-card">
                    <div className="title">Balance Leg Widget</div>
                    <div className="gap"></div>
                    {/* Individual Legs */}
                    <div className="column">
                        {
                            isPdownlineLoaded ? <>
                            <div className="widget-card">
                            <div className="flex-between">
                                <span className="widget-title">MP + CP</span>
                                <span className="widget-value">{asVolume(Number(myUser.qualification.mp) + Number(myUser.qualification.cp))}</span>
                            </div>
                        </div>
                                {pdownlineData.top3.map((leg, index) => (
                                    <div key={index} className="widget-card">
                                        <div className="flex-between">
                                            <span className="widget-title">{leg.name}</span>
                                            <span className="widget-value">{asVolume(leg.op)}</span>
                                        </div>
                                    </div>
                                ))}

                                {/* Other Legs */}
                                <div className="widget-card">
                                    <div className="flex-between">
                                        <span className="widget-title">Other Legs OP</span>
                                        <span className="widget-value">{pdownlineData.otherLegsOp.toLocaleString()}</span>
                                    </div>
                                </div>
                            </> :
                                <div style={{ height: 300 }}>
                                    <Spin spinning={true} className="loading-icon" />
                                </div>
                        }
                    </div>
                </div>
            </div>
        </Wrapper>
    );
}